export default {
    changeBind(state,isbind){
        state.isbind = isbind;
    },
    changeName(state,name){
        state.stu_name = name;
    },
    changeStuNumber(state,stunumber){
        state.stu_num = stunumber;
    },
    changePhone(state,phone){
        state.stu_phone = phone;
    },
    changeMajor(state,major){
        state.stu_major = major;
    },
    changeIdcard(state,idcard){
        state.stu_idcard = idcard;
    },
    changeOpen_id(state,open_id){
        state.open_id = open_id;
    },
    changeNickname(state,nickname){
        state.nickname = nickname;
    },
    changeHeadImgUrl(state,headImgUrl){
        state.headImgUrl = headImgUrl;
    },
}


//////////////////
// WEBPACK FOOTER
// ./store/mutations.js
// module id = null
// module chunks = 